import React from 'react';

import { Header } from './header';
import { OrderDetailsSection } from './order-details-section';
import { OrderItemsSection } from './order-items-section';
import { useEntitiesSalesOrder } from '../../../../hooks/entities/selectors/sales-orders';
import { useSalesOrderIdContext } from '../../../context/sales-order-id-context-provider';

import style from './order-summary.module.less';

export const OrderSummary = () => {
  const salesOrderId = useSalesOrderIdContext();
  const salesOrder = useEntitiesSalesOrder(salesOrderId) ?? {};
  const salesOrderItemCount = salesOrder?.items?.length;

  const salesOrderExists = !!salesOrder;

  if (!salesOrderExists) {
    return null;
  }

  return (
    <>
      <Header className={style.header} />
      <div className={style['order-summary-sections']}>
        <OrderDetailsSection />
        <OrderItemsSection salesOrderItemCount={salesOrderItemCount} />
      </div>
    </>
  );
};
